import { Component, NgModule, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DialogService } from '@service/dialog.service';
import { UserService } from '@service/user/user.service';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { ProfileModule } from 'src/app/profile.module';
import { SharedModule } from 'src/app/shared.module';
import { CompanyProfileInquiryDialogComponent } from '../company-profile-inquiry-dialog/company-profile-inquiry-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { ImageSliderComponentModule } from '@component/generic/image-slider/image-slider.component';
import { SliderImagesService } from '@service/slider-images.service';

@Component({
    selector: 'app-company-profile-inquiry-page',
    templateUrl: './company-profile-inquiry-page.component.html',
    styleUrls: ['./company-profile-inquiry-page.component.scss'],
    host: {
        '[class.noSlider]': '!hasSliderImages',
    },
})
export class CompanyProfileInquiryPageComponent implements OnInit {

    public isUserLoggedIn$: Observable<boolean>;

    public hasSliderImages: boolean = false;

    constructor(
        private userService: UserService,
        private dialogService: DialogService,
        private matDialog: MatDialog,
        private router: Router,
        public sliderImagesService: SliderImagesService
    ) {
        this.isUserLoggedIn$ = this.userService.userObservable.pipe(
            map(user => Boolean(user)),
        );

        this.isUserLoggedIn$.pipe(
            distinctUntilChanged(),
        ).subscribe(isLoggedIn => {
            if (isLoggedIn) {
                this.router.navigate(['/profile/business']);
            }
        });
    }

    newCarpenterProfile() {
        this.dialogService.loginRegistrationDialog("registration");
    }

    newCarpenterPlusProfile() {
        this.openInquiryDialog('CARPENTER_PLUS');
    }

    newOtherProfile() {
        this.openInquiryDialog('OTHER');
    }

    private openInquiryDialog(type: 'OTHER' | 'CARPENTER_PLUS') {
        const dialog = this.matDialog.open(CompanyProfileInquiryDialogComponent, {
            data: { type },
            minWidth: '40vw',
            maxWidth: '400px',
            maxHeight: '90vh',
            panelClass: ['black-centered-dialog', 'mobile-fullscreen'],
        });

        return dialog.afterClosed();
    }


    ngOnInit(): void {
        this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
            this.hasSliderImages = hasImages;
        });

        // TODO get the argument directly from the service / template instead of hard writing it
        this.sliderImagesService.checkHasSliderImages('publicCompanyProfile');
    }
}

@NgModule({
    declarations: [
        CompanyProfileInquiryPageComponent,
        CompanyProfileInquiryDialogComponent,
    ],
    imports: [
        SharedModule,
        ProfileModule,
        FormsModule,

        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,

        ImageSliderComponentModule,

        RouterModule.forChild([
            {
                path: '',
                component: CompanyProfileInquiryPageComponent,
            },
        ]),
    ],
})
export class CompanyProfileInquiryPageModule {

}
